import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SwimmingPoolForm from "../Components/SwimmingPoolForm";
import { saveSwimmingPoolCompany } from "../Reducers/actions";

const SwimmingPoolInsertPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    dispatch(saveSwimmingPoolCompany(values)).then((result) => {
      if (result.success) {
        alert("Zwembad succesvol aangemaakt!");
        navigate("/zwembadinspecties/zwembaden");
      } else {
        alert("Er is een fout opgetreden bij het aanmaken van het zwembad.");
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3>Nieuw Zwembad Toevoegen</h3>
            </div>
            <div className="card-body">
              <SwimmingPoolForm onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwimmingPoolInsertPage;
